import { z } from 'zod'

/**
 * Caselaw Metadata Reference Schema - V3
 * This is returned from the metadata endpoint `caselaw_v3/get_case_metadata?s3_path=<s3_path>`
 *
 * @description Schema for reference
 * @returns
 */
export const CaselawMetadataReferenceSchemaV3 = z.object({
  s3_path: z.string(),
  title: z.string(),
  citation: z.string(),
  bb_citation: z.string(),
  decide_date: z.string(), // ISO date
  jurisdiction_code: z.string(),
  parent_id: z.string(),
})

export type CaselawMetadataReferenceV3 = z.infer<typeof CaselawMetadataReferenceSchemaV3>

/**
 * Caselaw Metadata Reference Query Schema - V3
 * This is returned as part of conversation metadata, into each reference.
 *
 *
 * @description Schema for reference
 * @returns
 */
export const CaselawMetadataReferenceQuerySchemaV3 = z.object({
  chunk_id: z.string(),
  title: z.string(),
  decide_date: z.string(), // ISO date
  jurisdiction_code: z.string(),
  citation: z.string(),
  docket: z.string().optional(),
  alternative_citations: z.array(z.string()).nullable().optional(),
  precedential_status: z.string().nullable().optional(),
  bb_citation: z.string(),
  parent_id: z.string(),
  version: z.number(),
  s3_path: z.string(),
  judge: z.string().optional(),
  defendant: z.string().optional(),
  plaintiff: z.string().optional(),
  reference_type: z.string(),
})

export type CaselawMetadataReferenceQueryV3 = z.infer<typeof CaselawMetadataReferenceQuerySchemaV3>

/**
 * Caselaw HTML Response Schema - V3
 * This is returned from the html endpoint `caselaw_v3/get_case_html?s3_path=<s3_path>`
 *
 * @description Schema for reference
 * @returns
 */
export const CaselawReferenceHtmlResponseSchema = z.object({
  data: z.string(),
})

export type CaselawReferenceHtmlResponse = z.infer<typeof CaselawReferenceHtmlResponseSchema>
